import QRCode from "react-qr-code";
import { Button } from "./ui/button";
import { Printer } from "lucide-react";
import logo from "../assets/gfm-logo-square.png";

const ORIGIN = window.location.origin;
const CONTACT_LINE = "Questions? Contact the GFM site team — kcockram@gfm-uk.com";
function slugify(s) { return s.replace(/[^a-z0-9]+/gi, "-"); }

function printPoster(label, url) {
  const svg = document.getElementById(`qr-svg-${slugify(label)}`)?.querySelector("svg")?.outerHTML || "";
  const logoUrl = logo.startsWith("http") ? logo : ORIGIN + logo;
  const w = window.open("", "_blank", "width=820,height=1040");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>Scan to induct - ${label}</title>
  <style>@page{size:A4 portrait;margin:0}*{box-sizing:border-box}
  body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#00355e}
  .p{width:210mm;min-height:297mm;padding:18mm 20mm;text-align:center;display:flex;flex-direction:column;align-items:center}
  img.logo{height:26mm;margin-bottom:4mm}
  .brand{font-size:20px;font-weight:700;letter-spacing:2px;color:#0d6b8a;text-transform:uppercase}
  h1{font-size:38px;margin:6mm 0 2mm} h2{font-size:23px;margin:0 0 5mm;font-weight:500}
  .site{font-size:29px;font-weight:800;margin:3mm 0 5mm}
  .qr{border:2px solid #00355e;padding:6mm;border-radius:8px} .qr svg{width:110mm;height:110mm;display:block}
  ol{text-align:left;font-size:18px;line-height:1.9;max-width:150mm;margin:6mm auto 0}
  .url{margin-top:5mm;font-size:13px;color:#666;word-break:break-all}
  .contact{margin-top:auto;padding-top:6mm;font-size:16px;font-weight:600;color:#0d2a4b}</style></head>
  <body onload="setTimeout(function(){window.print()},400)">
  <div class="p"><img class="logo" src="${logoUrl}"/>
  <div class="brand">GFM · Permit to Work</div>
  <h1>Scan to complete your induction</h1><h2>Before you start work on site</h2>
  <div class="site">${label}</div>
  <div class="qr">${svg}</div>
  <ol><li>Open your phone camera and point it at the code.</li>
  <li>Sign in or register, then complete the induction checklist.</li>
  <li>Sign and submit — the site team will review and approve you.</li></ol>
  <div class="url">${url}</div>
  <div class="contact">${CONTACT_LINE}</div></div></body></html>`);
  w.document.close();
}

function QRTile({ label, url }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-md border border-border p-3 text-center" data-testid={`qr-tile-${label}`}>
      <div id={`qr-svg-${slugify(label)}`} className="rounded bg-white p-2"><QRCode value={url} size={120} fgColor="#00355e" /></div>
      <div className="text-xs font-semibold">{label}</div>
      <Button size="sm" variant="outline" className="w-full" onClick={() => printPoster(label, url)} data-testid={`print-poster-${label}`}>
        <Printer className="mr-1 h-3.5 w-3.5" /> Print A4 poster
      </Button>
    </div>
  );
}

export function SiteInductionQRGrid({ sites }) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3" data-testid="induction-qr-grid">
      <QRTile label="Any site (they choose)" url={`${ORIGIN}/self-induct`} />
      {sites.map((s) => <QRTile key={s} label={s} url={`${ORIGIN}/self-induct/${encodeURIComponent(s)}`} />)}
    </div>
  );
}
